// src/components/ClientPortalCommunicationLogs.js

import React from 'react';
import 'animate.css';

function ClientPortalCommunicationLogs({ currentUser, clients, communicationLogs, cases }) {
  // Find the specific client profile linked to the current user
  const clientProfile = clients.find(client => client.user === currentUser.id);

  // Filter communication logs relevant to this specific client profile or their cases
  const clientCommunicationLogs = communicationLogs.filter(log =>
    log.client === (clientProfile ? clientProfile.id : null) ||
    (log.case && cases.some(c => c.id === log.case && c.client === (clientProfile ? clientProfile.id : null)))
  );

  return (
    <div className="client-portal-communication-logs animate__animated animate__fadeInUp">
      <h2 className="mb-4 text-primary">Your Communication Logs</h2>
      {clientProfile ? (
        <p className="lead text-secondary">Review your communication history with the firm, {clientProfile.first_name} {clientProfile.last_name}.</p>
      ) : (
        <p className="lead text-warning">Your user account is not yet linked to a client profile. Please contact the firm administrator to view your communication logs.</p>
      )}

      {clientCommunicationLogs.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-hover table-striped shadow-sm rounded overflow-hidden">
            <thead className="bg-primary text-white">
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Summary</th>
                <th>Associated Case</th>
                <th>Logged By</th>
              </tr>
            </thead>
            <tbody>
              {(clientCommunicationLogs || []).map(log => (
                <tr key={log.id}>
                  <td>{new Date(log.communication_date).toLocaleDateString()}</td>
                  <td>{log.log_type}</td>
                  <td>{log.summary}</td>
                  <td>{log.case_title || 'N/A'}</td>
                  <td>{log.logged_by_username || 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="alert alert-info mt-4" role="alert">
          No communication logs found associated with your client profile or cases.
        </div>
      )}
    </div>
  );
}

export default ClientPortalCommunicationLogs;
